import { EnumerationsRole } from 'client'
import { EnumerationsFirstRoute } from 'client/identity'
import { PATH } from '~/constants/strings'

export interface IFirstRouteOptions {
  route: EnumerationsFirstRoute
  serviceLine?: string
  serviceDeliverableID?: string
  role?: EnumerationsRole
  shouldSeeSupportAccess: boolean
  supportAccessPath: `/${string}` | ''
}

export const getPathForFirstRoute = ({
  route,
  serviceLine,
  serviceDeliverableID,
  role,
  shouldSeeSupportAccess,
  supportAccessPath,
}: IFirstRouteOptions): `/${string}` | '' => {
  switch (route) {
    case EnumerationsFirstRoute.DocumentCenter:
      return PATH.DOCUMENT_CENTER

    case EnumerationsFirstRoute.DataVizOverview:
      if (!serviceLine) {
        break
      }
      return `/${serviceLine}/data-viz/overview`

    case EnumerationsFirstRoute.Reports:
      // If serviceLine is not provided, default to document-center.
      if (!serviceLine) {
        break
      }
      return `/${serviceLine}/reports`

    case EnumerationsFirstRoute.ServiceDeliverables:
      // Check if the role passed is BerkshireDataAdmin.
      if (role === EnumerationsRole.BerkshireDataAdmin) {
        return PATH.DOCUMENT_CENTER
      }
      // Only construct the path if serviceLine and serviceDeliverableID are provided.
      if (serviceLine && serviceDeliverableID) {
        return `/${serviceLine}/service-deliverables/${serviceDeliverableID}`
      }
      break

    case EnumerationsFirstRoute.SupportAccess:
      if (shouldSeeSupportAccess) {
        if (!supportAccessPath) {
          console.error(
            'Tried to send a user to support access without supplying a path'
          )
          break
        }
        return supportAccessPath
      }
      console.error(
        'Tried to send a user without Support Access permission to Support Access'
      )
      break

    default:
      return PATH.DOCUMENT_CENTER
  }
  return PATH.DOCUMENT_CENTER
}
